import { mapGetters, mapActions } from 'vuex'
import Constants from '@/utils/Constants'

export default {
  name: 'Password',
  metaInfo () {
    let title = this.pageTitle + ' | ' + Constants.SiteInfo.title
    this.setMeta({ title: title })
    return this.getMeta
  },
  mounted () {
    this.init()
  },
  computed: {
    ...mapGetters({
      getMeta: 'meta/get'
    }),
    pageTitle () {
      return 'パスワード変更'
    }
  },
  methods: {
    ...mapActions({
      setMeta: 'meta/set'
    }),
    init () {

    }
  }
}
